module.exports = __webpack_public_path__ + "static/media/art_institutions.2d02e7b8.jpg";